import { logEventToDecimal } from "../decimal/methods/events.ts";

type LoggableError = Error | string;

export const noticeError = (
  e: LoggableError,
  attrs?: Record<string, string | number>
) => {
  /* eslint-disable no-console */
  console.error(e);
  if (attrs) {
    console.log("error attributes", attrs);
  }
  /* eslint-enable no-console */
  // Must throw to ensure stack traces in all browsers in all situations
  // https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/noticeerror-browser-agent-api/#browser-limits
  try {
    throw e;
  } catch (err) {
    window.newrelic?.noticeError(err as LoggableError, attrs);
  }
};

export const logEvent = (
  id: string,
  params: Record<string, string | number> = {}
) => {
  // Doesn't go through the router so it can be called from anywhere, including outside of components
  void logEventToDecimal(id, params);
};

export const setAttribute = (key: string, value: string | number) => {
  window.newrelic?.setCustomAttribute(key, value);
};
